import { createFileRoute } from '@tanstack/react-router';
import { useFeatures } from '@/hooks/useFeatures';
import { usePermissions } from '@/hooks/usePermissions';
import {
  FACILITY_CAN_DO_NEW_INCOMING,
  FiberIncomingTable,
} from '../../../-components/FiberIncomingTable';
import { useFiberIncomingList } from '../../../-hooks/useFiberIncomingList';
import { useFiberSettings } from '../../../-hooks/useFiberSettings';

export const Route = createFileRoute(
  '/(client)/transactions/(pages)/(list)/incoming/',
)({
  component: IncomingTransactionsPage,
});

function IncomingTransactionsPage() {
  const listState = useFiberIncomingList();
  const { data: fiberSettings } = useFiberSettings();
  const { isFeatureEnabled } = useFeatures();

  const canWrite = usePermissions()['fiber-forward'].canCreate;
  const facilityCanOriginate =
    fiberSettings?.some(s => s.key === FACILITY_CAN_DO_NEW_INCOMING) ?? false;
  const canCreateIncoming = canWrite && facilityCanOriginate;
  const canImportIncoming =
    canCreateIncoming && isFeatureEnabled('incoming-transaction-upload');

  return (
    <FiberIncomingTable
      listState={listState}
      canCreateIncoming={canCreateIncoming}
      canImportIncoming={canImportIncoming}
      canReceive={canWrite}
    />
  );
}
